module.exports = __webpack_public_path__ + "jira-server.eb5e4a.svg";